import { faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { createRequestDefaultClipConfigurationAction } from '../../actions/clientActions';
import { ApiDataTypes } from '../../api/apiDataTypes';
import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';
import FormModal from '../modal/formModal';

import BaseClientForm from './baseClientForm';

interface NewClientFormStateProps extends BaseStateProps {
  defaultClipConfiguration: string;
  defaultClipConfigurationLoaded: boolean;
}

interface NewClientFormDispatchProps extends BaseDispatchProps {
  loadDefaultClipConfiguration: (c: NewClientForm) => void;
}

type NewClientFormState = {
  isDst: boolean;
};

class NewClientForm extends ComponentBase<{}, NewClientFormStateProps, NewClientFormDispatchProps, NewClientFormState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isDst: true,
    };
  }

  protected async loadData(props: any) {
    if (!props.defaultClipConfigurationLoaded) {
      await props.loadDefaultClipConfiguration(this);
    }
  }

  protected dataLoaded(props: any): boolean {
    return props.defaultClipConfigurationLoaded;
  }

  protected loggedInRender() {
    const handleTimezoneChange = (isDst: boolean) => {
      this.setState({ isDst });
    };

    return (
      <FormModal
        formId={FormId.AddClientForm}
        formTitle="New Client"
        submitActionType={DataRequestActionTypes.NewClientRequested}
        buttonIcon={faPlus}
        invertedButtonColours
        initialValues={{
          clipConfiguration: JSON.parse(this.props.defaultClipConfiguration),
          emails: false,
          survey: false,
          clipTemplateEditor: false,
          dst: this.state.isDst,
          colors: {
            primary: '#95C025',
            secondary: '#595984',
          },
        }}
      >
        <BaseClientForm formId={FormId.AddClientForm} onTimezoneChange={handleTimezoneChange} />
      </FormModal>
    );
  }
}

function mapStateToProps(state: ClippingPlatformState): NewClientFormStateProps {
  return {
    ...baseMapStateToProps(state),
    defaultClipConfiguration: state.singleEntity.defaultClipConfiguration,
    defaultClipConfigurationLoaded: state.appStatus.allLoaded[ApiDataTypes.DefaultClipConfiguration],
  };
}

function mapDispatchToProps(dispatch: Dispatch): NewClientFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadDefaultClipConfiguration: (c: NewClientForm) =>
      dispatch(createRequestDefaultClipConfigurationAction(c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewClientForm);
